import { PublishersTagsTable } from './publishers-tags-table';

export { PublishersTagsTable };
